import React from 'react';
import './Legal.css';

function Conditions() {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Conditions Générales</h1>
        <p>Dernière mise à jour: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="legal-content">
        <section>
          <h2>1. Services de Transport</h2>
          <p>TaxiVD propose les services suivants :</p>
          <ul>
            <li>Transport privé dans la région de Lausanne et environs</li>
            <li>Services de navette aéroport</li>
            <li>Transport d'entreprise</li>
            <li>Courses scolaires</li>
            <li>Services pour événements spéciaux</li>
          </ul>
        </section>

        <section>
          <h2>2. Réservations et Annulations</h2>
          <p>Politique de réservation :</p>
          <ul>
            <li>Réservation possible par téléphone ou en ligne</li>
            <li>Annulation gratuite jusqu'à 2 heures avant le départ</li>
            <li>Frais d'annulation de 50% si moins de 2 heures avant</li>
            <li>Absence non-annoncée facturée à 100%</li>
          </ul>
        </section>

        <section>
          <h2>3. Tarifs et Paiements</h2>
          <p>Nos tarifs sont calculés selon :</p>
          <ul>
            <li>La distance parcourue</li>
            <li>Le temps de trajet</li>
            <li>Le type de véhicule</li>
            <li>Les suppléments éventuels (nuit, bagages)</li>
          </ul>
        </section>

        <section>
          <h2>4. Responsabilités</h2>
          <p>Notre engagement :</p>
          <ul>
            <li>Ponctualité et fiabilité du service</li>
            <li>Respect des normes de sécurité</li>
            <li>Chauffeurs professionnels et qualifiés</li>
            <li>Véhicules propres et bien entretenus</li>
          </ul>
        </section>

        <section>
          <h2>5. Contact</h2>
          <div className="contact-info">
            <p>Pour toute question concernant nos conditions :</p>
            <p>Email: contact@taxivd.ch</p>
            <p>Téléphone: +41 XX XXX XX XX</p>
            <p>Adresse: Lausanne, Suisse</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Conditions; 